import { MessageCircle, Clock } from "lucide-react";
import useSiteConfig, { whatsappLinkFromCfg } from "@/lib/useSiteConfig";

/**
 * LongStayNudge — surfaces preferential-rate messaging when the guest is shopping for
 * an extended stay: either by selecting >30 nights on the calendar, or by landing on
 * the Long Stays & Workations collection.
 */
export default function LongStayNudge({ nights, compact = false, context = "search" }) {
  const cfg = useSiteConfig();
  const message = context === "collection"
    ? "Planning a monthly or extended stay? Our team offers preferential direct rates for long-term bookings — let's tailor the right home and terms for you."
    : `We noticed you're looking at ${nights ? `a ${nights}-night` : "a longer"} stay — we offer preferential direct rates for anything 30+ nights. Share your plans and we'll send a tailored proposal.`;

  const waMessage = `Hi Vyagram, I'd like to plan a long stay${nights ? ` (~${nights} nights)` : ""}. Could you share long-term rates?`;

  return (
    <div
      data-testid="long-stay-nudge"
      className={`rounded-2xl border border-gold/40 bg-gradient-to-br from-gold/10 to-parchment ${compact ? "p-4" : "p-5 sm:p-6"}`}
    >
      <div className="flex flex-wrap items-start gap-4">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forest/10 text-forest">
          <Clock size={16} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] uppercase tracking-[0.22em] text-amber">Long-stay preferred rates</p>
          <p className="mt-1 font-display text-lg text-forest sm:text-xl">Let's tailor the numbers for you.</p>
          <p className="editorial-body mt-1 !text-sm text-noir/75">{message}</p>
        </div>
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
          <a
            href={whatsappLinkFromCfg(cfg, waMessage)}
            target="_blank"
            rel="noreferrer"
            data-testid="long-stay-whatsapp"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-4 py-2.5 text-sm font-medium text-white transition-transform hover:-translate-y-0.5"
          >
            <MessageCircle size={15} /> Talk to us
          </a>
        </div>
      </div>
    </div>
  );
}
